import { track } from "../track";

export const trackTrendingSearchSubmit = (params: { query: string }) =>
  track({ event: "trending_search_submit", ...params });
